import { render, staticRenderFns } from "./NoticeManagement.vue?vue&type=template&id=50b93e91&scoped=true"
import script from "./NoticeManagement.vue?vue&type=script&lang=js"
export * from "./NoticeManagement.vue?vue&type=script&lang=js"
import style0 from "./NoticeManagement.vue?vue&type=style&index=0&id=50b93e91&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b93e91",
  null
  
)

export default component.exports